import type { RootState } from './store';

const STORAGE_KEY = 'mes.spc-session.v1';
const isSpcPage = (location: Pick<Location, 'pathname'>) => /^\/spcRequest\/?$/i.test(location.pathname);
const requestKey = (location: Pick<Location, 'search'>) => location.search;

export const restoreSpcSession = (): RootState | undefined => {
    if (!isSpcPage(window.location)) return undefined;

    try {
        const saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
        const state = saved?.state as RootState | undefined;
        if (saved?.requestKey !== requestKey(window.location) ||
            !state?.motor?.clientMotorResponse?.motorRequest || !state.motor.mesRequest?.commonData ||
            !state.diagram || !state.load || !state.gearbox || !state.startingConstraint ||
            !state.translation || !state.banner || !state.layout) {
            return undefined;
        }

        return state;
    } catch {
        // Storage can be disabled or contain an obsolete/corrupt snapshot.
        return undefined;
    }
};

export const saveSpcSession = (state: RootState): void => {
    // The successful Call SPC dispatches happen while the browser is still on
    // /testspc; navigation to /spcRequest follows afterwards. Save the state
    // based on its content, not on the current route.
    if (!state.motor.clientMotorResponse) return;

    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            requestKey: requestKey(window.location),
            state: {
                ...state,
                motor: {
                    ...state.motor,
                    loading: false,
                    showNumberOfStartupsDialog: false,
                    // An interrupted calculation must be rerun, not shown as current.
                    calculationResponse: state.motor.loading ? undefined : state.motor.calculationResponse
                },
                load: { ...state.load, showLoadInertiaLowDialog: false, showLoadInertiaHighDialog: false },
                gearbox: { ...state.gearbox, renderGearboxInertiaDialog: false }
            }
        }));
    } catch {
        // A storage quota/privacy restriction must not break the calculation UI.
    }
};
